// apps/web/src/admin/AdminAuditView.tsx
import { useEffect, useState } from 'react';
import { apiAdmin } from './apiAdmin.js';

const ACTIONS = ['promote','revoke','disable','enable','adjust_balance','end_call'] as const;

export function AdminAuditView() {
  const [rows, setRows] = useState<any[]>([]);
  const [action, setAction] = useState<string>('');
  useEffect(() => { void (async () => { const r = await apiAdmin.audit({ action: action || undefined }); setRows(r.rows); })(); }, [action]);
  return (
    <div>
      <div className="mb-4 flex gap-2 items-center text-sm">
        <label>Filter by action:</label>
        <select className="px-2 py-1 border rounded" value={action} onChange={(e) => setAction(e.target.value)}>
          <option value="">(any)</option>
          {ACTIONS.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>
      <table className="w-full text-xs">
        <thead className="text-left text-ink-500"><tr><th>When</th><th>Actor</th><th>Action</th><th>Target</th><th>Details</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{new Date(r.createdAt).toLocaleString()}</td>
              <td>{r.actor ? <>{r.actor.displayName}<br/><span className="text-ink-500">{r.actor.email}</span></> : 'System'}</td>
              <td>{r.action}</td>
              <td>{r.target ? <>{r.target.displayName}<br/><span className="text-ink-500">{r.target.email}</span></> : '—'}</td>
              <td><pre className="text-xs">{JSON.stringify(r.details, null, 2)}</pre></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
